/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _subject_fr = new IntlMessageFormat(
    [
        {
            type: 5,
            value: 'subject',
            options: {
                info: { value: [{ type: 0, value: 'Information' }] },
                appointment: { value: [{ type: 0, value: 'Demande de rendez-vous' }] },
                empty_value: { value: [{ type: 0, value: 'Choisisse' }] },
                information: { value: [{ type: 0, value: "Demande d'information" }] },
                information_or_quotation: {
                    value: [{ type: 0, value: "Demande d'information ou devis" }],
                },
                quotation: { value: [{ type: 0, value: 'Demande de devis' }] },
                job_application: { value: [{ type: 0, value: "Demande d'emploi" }] },
                product: {
                    value: [{ type: 0, value: "Demande d'information sur un produit" }],
                },
                service: { value: [{ type: 0, value: 'Demande de contact - services' }] },
                landing: {
                    value: [{ type: 0, value: 'Demande de contact - Landing pages' }],
                },
                prospect_from_a_category: {
                    value: [{ type: 0, value: 'Prospect depuis une catégorie' }],
                },
                company_appointment: {
                    value: [{ type: 0, value: 'Demande de rendez-vous de %fullname%' }],
                },
                company_information: {
                    value: [{ type: 0, value: "Demande d'information de %fullname%" }],
                },
                company_quotation: {
                    value: [{ type: 0, value: 'Demande de devis de %fullname%' }],
                },
                company_job_application: {
                    value: [{ type: 0, value: "Demande d'emploi de %fullname%" }],
                },
                company_product: {
                    value: [
                        {
                            type: 0,
                            value: "Demande d'information sur un produit de %fullname%",
                        },
                    ],
                },
                unsuspend: {
                    value: [{ type: 0, value: "Contact à propos d'une fiche suspendue" }],
                },
                request_link: { value: [{ type: 0, value: 'Demande de rattachement' }] },
                report_company: { value: [{ type: 0, value: 'Signaler une société' }] },
                report_feed_post: { value: [{ type: 0, value: 'Signaler le post' }] },
                other: { value: [{ type: 1, value: 'subject' }] },
            },
        },
        { type: 0, value: '\n' },
    ],
    'fr',
);

export function subject(
    args: {
        subject:
            | 'appointment'
            | 'company_appointment'
            | 'company_information'
            | 'company_job_application'
            | 'company_product'
            | 'company_quotation'
            | 'empty_value'
            | 'info'
            | 'information'
            | 'information_or_quotation'
            | 'job_application'
            | 'landing'
            | 'product'
            | 'prospect_from_a_category'
            | 'quotation'
            | 'report_company'
            | 'report_feed_post'
            | 'request_link'
            | 'service'
            | 'unsuspend'
            | number
            | string;
    },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _subject_fr.format(args) as unknown as string;
    }

    return _subject_fr.format(args) as unknown as string;
}
